import { RewardType } from '../../../Utility/Rewards/RewardType';

export const propsByRewardType: Record<
    RewardType,
    {
        asset: string;
        wheelAsset?: string;
        width?: number;
        scale?: number;
    }
> = {
    [RewardType.COINS]: { asset: 'wheel_coins', wheelAsset: 'coin_large', width: 160 },
    [RewardType.BOMB]: { asset: '' },
    [RewardType.JOKER]: { asset: 'hud_level_joker', width: 86 },
    [RewardType.UNDO]: { asset: '' },
    [RewardType.BULLSEYE]: { asset: '' },
    [RewardType.SHUFFLE]: { asset: '' },
    [RewardType.NONE]: { asset: '' },
    [RewardType.PLUS_FIVE_CARDS]: { asset: 'shop_5_cards', width: 90, scale: 0.9 },
    [RewardType.THREE_STAR_REWARD]: { asset: '' },
    [RewardType.PRIZE_WHEEL_SPIN]: { asset: '' },
    [RewardType.CARDS]: { asset: '' },
    [RewardType.OTHER]: { asset: '' },
    [RewardType.FREE_PLAY]: { asset: 'icon_free_level', scale: 1.2 },
    [RewardType.PET]: { asset: '' },
    [RewardType.PRE_BOOSTER_REMOVE_THREE]: { asset: 'booster_remove', scale: 0.8, width: 120 },
    [RewardType.PRE_BOOSTER_JOKER]: { asset: 'booster_joker', scale: 0.8, width: 120 },
    [RewardType.PRE_BOOSTER_CANISTER]: { asset: 'booster_canister', scale: 0.8, width: 120 },
    [RewardType.PREMIUM_SPIN]: { asset: '' },
    [RewardType.FARM_AREA]: { asset: '' },
    [RewardType.FARM_ITEM]: { asset: '' },
    [RewardType.PLINKO_TOKEN]: { asset: '' },
    [RewardType.SEASON_PASS_POINTS]: { asset: '' },
    [RewardType.PREMIUM_SEASON_PASS]: { asset: '' },
};
